export function isDocNotViewableInThisGV(
    viewableStatus?: DocViewableStatus
): viewableStatus is DocViewableStatus {
    return !!viewableStatus && viewableStatus !== 'VIEWABLE';
}
